import axios from 'axios';
import { API_URLS } from '../../urls';
import Cookies from 'js-cookie';

export const getUser = async (HOST, PORT, TOKEN) => {
  try {
    const accessToken = Cookies.get('access_token');

    const response = await axios.get(`${API_URLS.BASE_URL}user`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      maxBodyLength: Infinity
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};
